import { render } from "./deleteUser.vue?vue&type=template&id=b45870d4"
import script from "./deleteUser.vue?vue&type=script&lang=js"
export * from "./deleteUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__